require.register("export/controllers/kulturpoolCtrl", function(exports, require, module){
  $0
  
});

